import React, { useState } from "react";
import "./ExperienceSection.scss";
import { AllImages } from "../../Assets/Images/AllImages";
import user from "../../Common/JsonFiles/rohan.json";

const ExeperienceSection = () => {
  const [showDescription, setShowDescription] = useState(-1);

  const handleAccordionClick = (item, index) => {
    if (showDescription === index) {
      setShowDescription(-1);
      return;
    }
    setShowDescription(index);
  };

  return (
    <div className="experience-section-container">
      <div className="experience-section-heading">Professional Experience</div>
      {user?.experience?.map((item, index) => {
        return (
          <div className="experience-section-accordions">
            <div
              onClick={(e) => handleAccordionClick(item, index)}
              className={`experience-single-accordion ${
                showDescription === index ? "active" : ""
              }`}
            >
              <div className="exp-acc-title">{`${item.jobTitle} @ ${item.company}`}</div>
              <div className="exp-acc-years-img">
                <div className="exp-years">
                  {item.startDate} - {item.endDate}
                </div>
                <div className="exp-plus-min-img">
                  {showDescription === index ? "-" : "+"}
                </div>
              </div>
            </div>

            {true ? (
              <div
                className={`exp-company-description-container ${
                  showDescription === index ? "" : "height-0"
                }`}
              >
                <div className="exp-company-name-desc">
                  <div className="exp-cname-date">
                    <div className="exp-cname">{item.company}</div>
                    <div className="exp-date">
                      {item.startDate} - {item.endDate}
                    </div>
                  </div>

                  <div className="desc-content">
                    <div className="desc-location-url">
                      <div className="desc-comp-location">
                        <img src={AllImages.LocationIcon} alt="" />
                        <span>{item.location}</span>
                      </div>
                      <div className="desc-comp-url">
                        <img alt="" src={AllImages.URLIcon} />
                        <a
                          className="comp-url"
                          href={item.companyUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item.company}
                        </a>
                      </div>
                    </div>

                    <div className="exp-desc-text">{item.description}</div>

                    <div className="exp-skills-tags">
                      {item.SkillsUsed.map((i) => {
                        return <div className="skill-tag">{i}</div>;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default ExeperienceSection;
